import React, { CSSProperties } from 'react';
import clsx from 'clsx';
import Tooltip from '@srm/ui/tooltip';
import type { IMatrixMarker } from '../WinnerSelection2.types';
import { markerColorOf } from '../utils/matrixView';

/** Цветовой маркер контрагента из заявки: пилюля цвета справочника с названием маркера. */
const CounterpartyMarker: React.FC<{ marker: IMatrixMarker }> = ({ marker }) => {
    const color = markerColorOf(marker.color);
    const label = marker.name ? `Маркер контрагента: ${marker.name}` : 'Маркер контрагента';
    return (
        <Tooltip openDelay={100} background="black" position="bottom" label={label}>
            <span
                className={clsx('ws2-participant__marker', !color && 'ws2-participant__marker--empty')}
                style={color ? ({ '--ws2-marker-color': color } as CSSProperties) : undefined}
                role="img"
                aria-label={label}
            >
                <span className="ws2-participant__marker-dot" aria-hidden />
                {marker.name && <span className="ws2-participant__marker-name">{marker.name}</span>}
            </span>
        </Tooltip>
    );
};

export default CounterpartyMarker;
